import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import TVChannelsListBlockData from 'app/Models/Content/TVChannelsListBlockData';
import CategoryRefBLockData from 'Models/Content/CategoryRefBLockData';
import TVChannelItemBlockData from 'Models/Content/TVChannelItemBlockData';
import React, {useEffect, useState} from 'react';
import {Container} from 'reactstrap';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation} from 'swiper';
import 'swiper/swiper.scss';
import TabButtonTvChannel from './TabButtonTvChannel';
import TVChannelSlide from './TVChannelSlide';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';

SwiperCore.use([Navigation]);

const TVChannelsListBlock = ({data, context}: ComponentProps<TVChannelsListBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  const items = data.items.expandedValue as TVChannelItemBlockData[];
  const contentsCategories = data.contentsCategories.expandedValue as CategoryRefBLockData[];

  const [selectedCategory, setSelectedCategory] = useState(contentsCategories[0].id.value);
  const [allFilteredItems, setAllFilteredItems] = useState<TVChannelItemBlockData[] | undefined>(undefined);

  useEffect(() => {
    const filteredItems = items.filter((item) =>
      item.relatedCategory.expandedValue.some((selectedItem: CategoryRefBLockData) => {
        return selectedItem.id.value == selectedCategory;
      })
    );

    setAllFilteredItems(filteredItems);
  }, [selectedCategory]);

  const toggleArrows = (swiper: SwiperCore) => {
    setTimeout(() => {
      if (swiper.isBeginning && swiper.isEnd) {
        swiper.navigation?.nextEl?.classList.add('hide');
        swiper.navigation?.prevEl?.classList.add('hide');
      } else {
        swiper.navigation?.nextEl?.classList.remove('hide');
        swiper.navigation?.prevEl?.classList.remove('hide');
      }
    });
  };

  return (
    <div ref={ref} className={`TVChannelsListBlock ${fadeClass}`}>
      {data.title?.expandedValue?.map(({text, highlightText}: MarketingTextBlockData, i: number) => (
        <h2 key={i} className='TVChannelsListBlock__title'>
          {getTextWithHighlight({text: text.value, highlightText: highlightText.value})}
        </h2>
      ))}

      {data.blockSubtitle?.value && <div className='TVChannelsListBlock__subtitle'>{data.blockSubtitle.value}</div>}
      <Container>
        <div className='TVChannelsListBlock__content-categories' role='tablist' aria-label='קטגוריות ערוצים'>
          {/* mobile */}

          <div className='TVChannelsListBlock__content-categories__tabs mobile d-md-none'>
            {data.contentsCategories.expandedValue.map(({id, name}: CategoryRefBLockData) => (
              <TabButtonTvChannel
                key={id.value}
                onClick={() => {
                  setSelectedCategory(id.value);
                }}
                title={name.value}
                selected={selectedCategory === id.value}
                controls={`content-${id.value}`}
              />
            ))}
          </div>

          {/* desktop */}

          <div className='TVChannelsListBlock__content-categories__tabs desktop'>
            {data.contentsCategories.expandedValue.map(({id, name}: CategoryRefBLockData) => (
              <TabButtonTvChannel
                key={id.value}
                onClick={() => {
                  setSelectedCategory(id.value);
                }}
                title={name.value}
                selected={selectedCategory === id.value}
                controls={`content-${id.value}`}
              />
            ))}
          </div>
        </div>
      </Container>
      <Container fluid>
        {/* mobile */}

        <Swiper
          className='TVChannelsListBlock__swiper d-md-none d-lg-none d-xl-none'
          slidesPerView={3.3}
          spaceBetween={10}
          slidesPerColumn={2}>
          {allFilteredItems?.map((item, i) => (
            <SwiperSlide key={i} className={`TVChannelsListBlock__swiper__slide`}>
              <TVChannelSlide item={item} context={context} />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* desktop */}

        <Swiper
          centerInsufficientSlides
          navigation={{
            nextEl: '.tv-channel-swiper-nextEl',
            prevEl: '.tv-channel-swiper-prevEl',
          }}
          watchOverflow
          slidesPerView='auto'
          spaceBetween={16}
          onInit={toggleArrows}
          onResize={toggleArrows}
          className='TVChannelsListBlock__swiper d-none d-md-block d-lg-block d-xl-block'>
          {items.map((item) => {
            return item.relatedCategory.expandedValue.map((selectedItem: CategoryRefBLockData, i) => {
              if (selectedItem.id.value === selectedCategory) {
                return (
                  <SwiperSlide key={i} className={`TVChannelsListBlock__swiper__slide`}>
                    <TVChannelSlide item={item} context={context} />
                  </SwiperSlide>
                );
              }
            });
          })}
          <div className='tv-channel-swiper-nextEl'>
            <Image src={require('./images/left-icon.svg')} />
          </div>

          <div className='tv-channel-swiper-prevEl'>
            <Image src={require('./images/right-icon.svg')} />
          </div>
        </Swiper>
      </Container>
    </div>
  );
};

export default TVChannelsListBlock;
